module.exports = __webpack_public_path__ + "assets/img/hbyd.c0e487cc.png";